import React from "react";

import { StyledGrid } from "components/simple";
import { BHITitle, Body, Index } from "./styled";

interface SingleCycleProps {
  indexScore: number;
}

const SingleCycle: React.FC<SingleCycleProps> = ({ indexScore }) => {
  return (
    <StyledGrid item textAlign="center">
      <BHITitle>Your BrainHealth Index</BHITitle>
      <Body>This participant has only one BrainHealth assessment score finalized.</Body>
      <StyledGrid>
        <Index>{indexScore.toFixed(1)}</Index>
      </StyledGrid>
    </StyledGrid>
  );
};

export default SingleCycle;
